import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';

// Status indicator shared across all sidebar Status rows. Mirrors the
// documents-tab style (green check / grey circle + small pill badge text)
// so DEC / Benefits / Onboarding / CPP / QPP rows all look consistent.
// Read-only — for click-to-toggle rows use SidebarStatusToggle.
export function SidebarStatusBadge({
  confirmed,
  readyLabel = 'Ready',
  notReadyLabel = 'Pending',
}: {
  confirmed: boolean;
  readyLabel?: string;
  notReadyLabel?: string;
}) {
  return (
    <span className="inline-flex items-center gap-1.5">
      {confirmed
        ? <CheckCircle2 className="w-5 h-5 text-green-600" aria-hidden="true" />
        : <Circle className="w-5 h-5 text-gray-300" aria-hidden="true" />}
      <span
        className={
          'text-[10px] font-medium px-1.5 py-0.5 rounded ' +
          (confirmed ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500')
        }
      >
        {confirmed ? readyLabel : notReadyLabel}
      </span>
    </span>
  );
}

// A sidebar Status row whose label + badge both open a review/action modal.
// Used by the CPP / QPP benefit-form rows.
export function ClickableFormRow({
  label,
  confirmed,
  onClick,
}: {
  label: string;
  confirmed: boolean;
  onClick: () => void;
}) {
  return (
    <div className="flex justify-between items-center py-1.5">
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        style={{ color: '#2563eb' }}
        className="text-[13px] hover:underline leading-5 shrink-0 focus:outline-none focus:ring-2 focus:ring-ring rounded text-left font-medium"
      >
        {label}
      </button>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        className="inline-flex items-center gap-1.5 cursor-pointer rounded hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-ring"
      >
        <SidebarStatusBadge confirmed={confirmed} readyLabel="Completed" notReadyLabel="Pending" />
      </button>
    </div>
  );
}

export default ClickableFormRow;
